import styled from 'styled-components/macro';

export const TabsWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin: var(--space-xs) 0px;
`;

export const TabWrapper = styled.div<{ isSelected: boolean }>`
    border: none;
    background: ${({ isSelected }) => (isSelected ? '#6c757d' : '#f2f2f2')};
    border-radius: 8px;
    color: ${({ isSelected }) => (isSelected ? '#fff' : '#000')};
    opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
    font-size: 14px;
    line-height: 16px;
    font-style: normal;
    font-weight: 400;
    white-space: nowrap;
    padding: 8px 10px;
    cursor: pointer;
    margin-right: 12px;
    margin-top: 5px;
`;

export const WidgetWrapper = styled.div`
    /* margin-top: var(--space-sm); */
    position: relative;
`;

export const ChartWrapper = styled.div``;
